export const paths = {
  OVERVIEW: '',
  SIGNUP: 'sign-up',
  PROMOTION: 'promotion',
}

export const dhlExtraLinks = {
  dhlExtraOverviewLink: () => '',
  dhlExtraSignUpLink: () => `/${paths.SIGNUP}`,
  dhlExtraPromotionDetails: ({ promotionId }: { promotionId: string }) => `/${paths.PROMOTION}/${promotionId}`,
}

export type DhlExtraLinks = typeof dhlExtraLinks
